import React, { useState, useEffect,useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './OTPPage.css';
import logo from '../../shared/assets/logopng.png'; // Replace with your actual logo path
import illustration from '../../shared/assets/otp_img.png'; // Replace with your OTP illustration path
import editIcon from '../../shared/assets/Vector.png'; // Replace with your actual edit icon image path
import { toast } from 'react-toastify';
import { authService } from './services/authService';
import { useAuth } from '../../contexts/AuthContext';
import { useSnackbar } from '../../contexts/SnackbarContext';
import { MOBILE_BREAKPOINT, SPLASH_DURATION } from '../../shared/constants/uiConstants';
import { IoMailOpenOutline } from 'react-icons/io5';

const OTPPage = () => {
  const [otp, setOtp] = useState(['', '', '', '', '', '']);
  const [isResendEnabled, setIsResendEnabled] = useState(false);
  const [timer, setTimer] = useState(300); // Countdown timer (5 minutes = 300 seconds)
  const [isLoading, setIsLoading] = useState(false);
  const [isOtpExpired, setIsOtpExpired] = useState(false);
  const navigate = useNavigate(); // Use navigate for routing
  const location = useLocation(); // Get location state (phone number)
  const phoneNumber = location?.state?.phoneNumber || '';
  const { login } = useAuth();
  const { showSnackbar } = useSnackbar();
  const [showSplash, setShowSplash] = useState(false);

  const checkMobileAndShowSplash = useCallback(() => {
    const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
    if (isMobile) {
      setShowSplash(true);
      const timer = setTimeout(() => setShowSplash(false), SPLASH_DURATION);
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    return checkMobileAndShowSplash();
  }, [checkMobileAndShowSplash]);


  useEffect(() => {
    // Timer countdown from 5 minutes (300 seconds)
    if (timer > 0) {
      const countdown = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(countdown); // Clear the interval when timer reaches 0
            setIsResendEnabled(true); // Enable resend button when timer reaches 0
            setIsOtpExpired(true); // Mark OTP as expired
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(countdown); // Clean up the timer on component unmount
    }
  }, [timer]); // This useEffect runs every time the timer value changes

  // Handle OTP change with backspace support
  const handleOtpChange = (e, index) => {
    const value = e.target.value;
    if (value.match(/[0-9]/)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move focus to the next input field
      if (index < 5 && value !== '') {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }

      // Auto-verify when all 6 digits are filled
      if (newOtp.every(digit => digit !== '') && !isLoading) {
        verifyOtp(newOtp.join(''));
      }
    }
  };

  // Handle backspace and delete functionality
  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' || e.key === 'Delete') {
      const newOtp = [...otp];
      newOtp[index] = '';
      setOtp(newOtp);
      
      // Move focus to the previous input field on backspace
      if (e.key === 'Backspace' && index > 0) {
        document.getElementById(`otp-input-${index - 1}`).focus();
      }
    }
  };

  // Handle paste functionality
  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text');
    const digits = pastedData.replace(/\D/g, '').slice(0, 6);
    
    if (digits.length === 6) {
      const newOtp = digits.split('');
      setOtp(newOtp);
      document.getElementById('otp-input-5').focus();
      
      // Auto-verify when pasted
      if (!isLoading) {
        verifyOtp(digits);
      }
    }
  };

  // Verify OTP function
  const verifyOtp = async (otpString) => {
    if (isOtpExpired) {
      showSnackbar('Invalid OTP - OTP has expired', 'error');
      return;
    }

    setIsLoading(true);
    try {
      const data = await authService.verifyOTP(phoneNumber, otpString);
      console.log('OTP verification response:', data);
      
      if (data.success) {
        // Extract token and user from correct location
        const token = data.data?.access_token;
        const user = data.data;
        console.log(`user details in otp section ${user}`);
        // Update AuthContext with login state
        const success = await login(token, user);
        if (success) {
          navigate('/dashboard');
        } else {
          showSnackbar('Failed to save login data. Please try again.', 'error');
        }
      } else {
        showSnackbar('Invalid OTP. Please try again.', 'error');
      }
    } catch (error) {
      console.error('OTP verification error:', error);
      showSnackbar('Failed to verify OTP. Please try again.', 'error',);
    } finally {
      setIsLoading(false);
    }
  };

  // Handle form submission (OTP verification)
  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    const otpString = otp.join('');
    if (otpString.length === 6) {
      verifyOtp(otpString);
    }
  };

  // Resend OTP functionality with API call
  const handleResendOtp = async () => {
    try {
      await authService.sendOTP(phoneNumber);
      setIsResendEnabled(false);
      setIsOtpExpired(false);
      setTimer(300); // Reset the timer to 5 minutes (300 seconds)
      setOtp(['', '', '', '', '', '']); // Clear OTP fields
      toast.success('OTP sent successfully');
    } catch (error) {
      toast.error('Failed to send OTP. Please try again.');
    }
  };

  // Navigate to the edit phone number page
  const handleEditPhoneNumber = () => {
    navigate('/login'); // Navigate back to the login page
  };

  return (
    <div className="otp-page">

      {/* Splash Screen for Mobile */}
      {showSplash && (
        <div className="splash-screen">
          <img src={logo} alt="TykVen Logo" className="logoLogin" />
          <h1 className="app-title">TykVen Client</h1>
          <p className="app-subtitle">The Field Service Manager</p>
        </div>
      )}



  {/* Main Content */}
      {!showSplash && (
        <div className="content-wrapper">
        {/* Left Section for Desktop */}
        <div className="left-section">
          <img src={logo} alt="TykVen Logo" className="logo" />
          <h1 className="app-title">TykVen Client</h1>
          <p className="app-subtitle">The Field Service Manager</p>
        </div>

        {/* Right Section for OTP Form */}
        <div className="right-section">
          <form className="otp-form" onSubmit={handleVerifyOtp}>
            <img
              src={illustration}
              alt="OTP Illustration"
              className="form-illustration"
            />
            <h2 className="form-title">Verification Code</h2>
            <p className="form-subtitle">
              Enter the code from the SMS we sent to{' '}
              <strong>{phoneNumber}</strong>
              <img
                src={editIcon}
                alt="Edit Icon"
                className="edit-icon"
                onClick={handleEditPhoneNumber}
              />
            </p>

            {/* Timer Above OTP Input */}
            <div className="timer">
              {timer > 0 ? (
                <span>Resend in {Math.floor(timer / 60)}:{(timer % 60).toString().padStart(2, '0')}</span>
              ) : (
                <span></span> // Empty when timer reaches 0
              )}
            </div>

            {/* OTP Input Fields (6 Rectangles) */}
            <div className="otp-input-group">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  id={`otp-input-${index}`}
                  type="text"
                  maxLength="1"
                  value={digit}
                  onChange={(e) => handleOtpChange(e, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  onPaste={handlePaste}
                  className="otp-input"
                  autoFocus={index === 0}
                />
              ))}
            </div>

            {/* Resend Button (below OTP input fields after timer reaches 0) */}
            {isResendEnabled && (
              <button
                type="button"
                className="resend-button"
                onClick={handleResendOtp}
              >
                I didn’t receive any code. <span style={{color: '#4960F9'}}>RESEND</span>
              </button>
            )}

            {isLoading ? (
                 <div className="otp-overlay">
                       <div className="otp-loader-box">
                         <div className="otp-spinner"></div>
                         <div className="otp-icon">
                           <IoMailOpenOutline />
                         </div>
                       </div>
                     </div>
            ) : (
              <button type="submit" className="verify-button">
                Submit
              </button>
            )}
          </form>
        </div>
      </div>
            )}
    </div>
  );
};

export default OTPPage;
